import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getPAProductsSlice = createSlice({
  name: "getPAProducts",
  initialState,
  reducers: {
    getPAProductsStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getPAProductsSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getPAProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getPAProductsStart,
  getPAProductsSuccess,
  getPAProductsFailure,
  clearError,
  clearMessage,
} = getPAProductsSlice.actions;

export default getPAProductsSlice.reducer;
